module.exports = __webpack_public_path__ + "static/img/support-top.7b3eead5.jpg";